import { AutomationFormKeys } from 'domains/attendancePolicy/components/RuleForm/types'

export const automationTypeForm: Record<string, AutomationFormKeys> = {
  Gatilho: 'TRIGGER',
  Condição: 'CONDITION',
  Ação: 'ACTION',
}
